/* shipping-bar.js — standalone controller for the free shipping bar */
(function () {
  'use strict';

  var BAR_SEL = '#FreeShippingBar';
  var PRODUCTS_SEL = '[data-products]'; // drawer body in your markup
  var CART_DRAWER_SEL = '#CartDrawer';
  var PROGRESS_SEL = '[data-progress-bar]';

  // --- small helpers --------------------------------------------------------
  function $(sel, root) { return (root || document).querySelector(sel); }

  function formatMoney(cents, format) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, format || '{{amount}}');
      }
    } catch (e) {}
    var amt = (cents / 100).toFixed(2);
    return (format || '${{amount}}')
      .replace('{{amount}}', amt)
      .replace('{{ amount }}', amt);
  }

  function ensureConfetti(root) {
    if (root.querySelector('.confetti')) return;
    var wrap = document.createElement('div');
    wrap.className = 'confetti';
    for (var i = 1; i <= 6; i++) {
      var s = document.createElement('span');
      s.className = 'confetti__dot confetti__dot--' + i;
      wrap.appendChild(s);
    }
    (root.querySelector('.Drawer__Container') || root).appendChild(wrap);
  }

  function removeConfetti(root) {
    var c = root.querySelector('.confetti');
    if (c) c.remove();
  }

  function readLimit(bar) {
    var raw = bar && (bar.dataset.freeShippingLimit || '').trim();
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n; // units (e.g., 50.00)
  }

  // --- core render ----------------------------------------------------------
  function renderFromCart(bar, cart) {
    if (!bar || !cart) return;

    // Re-query each time (DOM may have been re-rendered)
    var progressEl = bar.querySelector('[data-progress-bar]');
    var defaultMsg = bar.querySelector('.free-shipping__default-message');
    var successMsg = bar.querySelector('.free-shipping__success-message');
    var amountSpan = bar.querySelector('.js-remaining-amount');
    var moneyFormat = bar.dataset.moneyFormat || '{{amount}}';

    var limit = parseFloat(bar.dataset.freeShippingLimit || '0');
    if (!limit) return;

    var total = (cart.total_price || 0) / 100;
    var pct = Math.max(0, Math.min(100, (total / limit) * 100));
    var remainingCents = Math.max(0, Math.round((limit - total) * 100));
    var qualifies = remainingCents === 0;

    if (progressEl) progressEl.setAttribute('value', String(pct));

    if (qualifies) {
        bar.classList.add('is-success');
        if (defaultMsg) defaultMsg.style.display = 'none';
        if (successMsg) successMsg.style.display = 'block';
        ensureConfetti(bar);
    } else {
        bar.classList.remove('is-success');
        if (successMsg) successMsg.style.display = 'none';
        if (defaultMsg) {
        if (amountSpan) amountSpan.textContent = formatMoney(remainingCents, moneyFormat);
        defaultMsg.style.display = 'inline';
        }
        removeConfetti(bar);
    }
    }


  function fetchCartAndRender(bar) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { renderFromCart(bar, cart); })
      .catch(function () { /* noop */ });
  }

  // --- detection: intercept cart mutations even if the theme is silent -----
  function hookNetwork(bar) {
    // Intercept fetch
    if (!window.__freeShip_fetchHooked) {
      var _fetch = window.fetch;
      window.fetch = function () {
        try {
          var url = arguments[0];
          var isReq = typeof url === 'string' ? url : (url && url.url);
          var willTouchCart = /\/cart\/(add|change|update)\.js(\?|$)/.test(isReq || '');
          return _fetch.apply(this, arguments).then(function (res) {
            if (willTouchCart && res && res.ok) {
              // Give the theme a moment to update DOM, then refresh
              setTimeout(function () { fetchCartAndRender(bar); }, 120);
            }
            return res;
          });
        } catch (e) {
          return _fetch.apply(this, arguments);
        }
      };
      window.__freeShip_fetchHooked = true;
    }

    // Intercept XHR
    if (!window.__freeShip_xhrHooked && 'XMLHttpRequest' in window) {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      var lastURL = '';
      XMLHttpRequest.prototype.open = function (m, u) {
        lastURL = String(u || '');
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        var watched = /\/cart\/(add|change|update)\.js(\?|$)/.test(lastURL);
        if (watched) {
          xhr.addEventListener('load', function () {
            if (xhr.status >= 200 && xhr.status < 300) {
              setTimeout(function () { fetchCartAndRender(bar); }, 120);
            }
          });
        }
        return origSend.apply(this, arguments);
      };
      window.__freeShip_xhrHooked = true;
    }
  }

  // --- fallback: observe cart drawer DOM mutations -------------------------
  function hookMutations(bar) {
    var root = $(PRODUCTS_SEL) || $(CART_DRAWER_SEL) || document.body;
    if (!root || !('MutationObserver' in window)) return;

    var mo = new MutationObserver(function () {
      // throttle a bit
      if (mo.__t) clearTimeout(mo.__t);
      mo.__t = setTimeout(function () { fetchCartAndRender(bar); }, 80);
    });

    mo.observe(root, { childList: true, subtree: true });
  }

  // --- init ----------------------------------------------------------------
  function init() {
    var bar = $(BAR_SEL);
    if (!bar) return;

    // Initial render
    fetchCartAndRender(bar);

    // Keep it updated
    hookNetwork(bar);   // detect AJAX cart calls
    hookMutations(bar); // fallback if theme modifies DOM without network (e.g., optimistic UI)

    // Update when drawer opens (covers first open)
    document.addEventListener('cart:open', function () { fetchCartAndRender(bar); });
    document.addEventListener('ajaxProduct:added', function (e) {
      // Some themes pass cart in event detail
      if (e && e.detail && e.detail.cart) renderFromCart(bar, e.detail.cart);
      else fetchCartAndRender(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
